// Premissas obrigatórias da Capa (etapa 6 — Análise de Viabilidade Financeira) e checagem do que o
// Comercial preenche depois (Projeção de Vendas por sabor) contra essas premissas.

import { gramaturaKg } from './rampaIndicadores';

export interface Premissas {
  cpv_kg?: number; // custo CPV estimado (R$/kg)
  cpv_un?: number; // custo CPV estimado (R$/un.)
  preco_venda_kg?: number; // PV estimado (R$/kg)
  preco_venda_un?: number; // PV estimado (R$/un.)
  pco_un?: number; // PCO: preço sugerido ao consumidor (R$/un.)
  margem_min?: number; // margem mínima exigida (%)
}

export const NOME_ETAPA_VIABILIDADE = 'Análise de Viabilidade Financeira';
export const ETAPA_VIABILIDADE_PADRAO = 6;

/** CPV por unidade = CPV/kg × gramatura (kg). Calculado — ninguém digita. undefined se faltar CPV ou gramatura. */
export function cpvUnitario(cpvKg: number | undefined, gramatura: string | undefined): number | undefined {
  const g = gramaturaKg(gramatura);
  if (cpvKg == null || !(cpvKg > 0) || g == null) return undefined;
  return Math.round(cpvKg * g * 10000) / 10000;
}

const CAMPOS: (keyof Premissas)[] = ['cpv_kg', 'cpv_un', 'preco_venda_kg', 'preco_venda_un', 'pco_un', 'margem_min'];

/** Todas as premissas preenchidas (> 0): é o que conclui a etapa 6 no PD1. */
export function premissasCompletas(p: Premissas): boolean {
  return CAMPOS.every((k) => (p[k] ?? 0) > 0);
}

export function premissasFaltando(p: Premissas): (keyof Premissas)[] {
  return CAMPOS.filter((k) => !((p[k] ?? 0) > 0));
}

export interface SaborReal {
  custo_kg?: number;
  preco_un?: number;
  preco_kg?: number;
}
export interface DesvioSabor {
  custoKg: boolean; // custo real acima do CPV estimado
  precoKg: boolean; // preço real abaixo do PV estimado
  precoUn: boolean;
  margem: boolean; // margem real abaixo da mínima
  textos: string[];
}

const EPS = 0.005;

/** Compara o que o Comercial preencheu para um sabor com as premissas. true = fora da premissa (vermelho). */
export function desviosSabor(p: Premissas, s: SaborReal): DesvioSabor {
  const textos: string[] = [];
  const custoKg = p.cpv_kg != null && p.cpv_kg > 0 && s.custo_kg != null && s.custo_kg > p.cpv_kg + EPS;
  if (custoKg) textos.push(`custo/kg ${s.custo_kg} acima do CPV estimado (${p.cpv_kg})`);
  const precoKg = p.preco_venda_kg != null && p.preco_venda_kg > 0 && s.preco_kg != null && s.preco_kg > 0 && s.preco_kg < p.preco_venda_kg - EPS;
  if (precoKg) textos.push(`preço/kg ${s.preco_kg} abaixo do PV estimado (${p.preco_venda_kg})`);
  const precoUn = p.preco_venda_un != null && p.preco_venda_un > 0 && s.preco_un != null && s.preco_un > 0 && s.preco_un < p.preco_venda_un - EPS;
  if (precoUn) textos.push(`preço/un. ${s.preco_un} abaixo do PV estimado (${p.preco_venda_un})`);
  let margem = false;
  if (p.margem_min != null && p.margem_min > 0 && s.custo_kg != null && s.preco_kg != null && s.preco_kg > 0) {
    const mc = ((s.preco_kg - s.custo_kg) / s.preco_kg) * 100;
    margem = mc < p.margem_min - EPS;
    if (margem) textos.push(`margem ${mc.toFixed(1)}% abaixo da mínima (${p.margem_min}%)`);
  }
  return { custoKg, precoKg, precoUn, margem, textos };
}
